import React from 'react';
import {Redirect} from "react-router-dom";

export const RedirectToUsers = () => <Redirect to={'/users'}/>;
